/**
 * @example
 * const languages = {
 *     "1": "English",
 *     "2": "German",
 *     "3": "French"
 * };
 *
 * const sortedLanguages = sortObjectValuesAsArray(languages);
 * // Output: [{ key: "1", value: "English" }, { key: "3", value: "French" }, { key: "2", value: "German" }]
 */
export function sortObjectValuesAsArray(obj: { [key: string]: string }, reverse = false): { key: string; value: string }[] {
    return Object.entries(obj)
        .sort((a, b) => {
            if (reverse) {
                return b[1].localeCompare(a[1]);
            }
            return a[1].localeCompare(b[1]);
        })
        .map(([key, value]) => {
            return { key, value };
        });
}
